
import { requestApiManager } from './requestApiManager';
import { RECAPTCHA } from '../main_config';
import { dtext } from "../utils/cutils";

const generateRandomDeviceId = () => 
  Math.random()
    .toString(36)
    .substring(2, 15) + 
  Math.random()
    .toString(36)
    .substring(2, 15);


export const getTokenApiManager = tokenCaptcha => {
  const dusrLoginName = dtext(RECAPTCHA.APIMANAGERUSER);
  const dpassword = dtext(RECAPTCHA.APIMANAGERPASS);
  const dapiKey = dtext(RECAPTCHA.APIMANAGERKEY);
  return requestApiManager({
    url: '/cl/api-smg/v0/auth-login',
    method: 'post',
    data: {
      recaptchaResponse: tokenCaptcha,
      usrLoginName: dusrLoginName,
      password: dpassword,
      apiKey: dapiKey,
      device: {
        bloqueado: true,
        recordar: true,
        deviceid: generateRandomDeviceId(),
        messagingid: "----",
        devicename: "Google Chrome"
      }
    }
  });
}